module.exports = __webpack_public_path__ + "static/media/14.2e652ac8.jpeg";